import React from "react";

function DepartmentSelect({ departments, value, onChange }) {
  return (
    <select
      value={value}
      onChange={onChange}
      className="p-2 border rounded-md w-full"
    >
      <option value="">Select Department</option>
      {departments.map((dept) => (
        <option key={dept.id} value={dept.id}>
          {dept.title} {/* ✅ matches your model */}
        </option>
      ))}
    </select>
  );
}

export default DepartmentSelect;
